import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private http: HttpClient
  ) { }

  login(loginPayload: any): Observable<any> {
    return this.http.post<any>(`${environment.apiURL}/admin/login`, loginPayload);
  }

  refresh(): Observable<any> {
    return this.http.post<any>(`${environment.apiURL}/admin/refresh`, {});
  }

  logout(): Observable<any> {
    return this.http.post<any>(`${environment.apiURL}/admin/logout`, {});
  }

  adminLogo(): Observable<any> {
    return this.http.get<any>(`${environment.apiURL}/admin/logo`)
  }

  forgotPassword(resetPasswordPayload: any): Observable<any> {
    return this.http.post<any>(`${environment.apiURL}/admin/forgotPassword`, resetPasswordPayload)
  }

  get logo() {
    return localStorage.getItem('logo');
  }
}
